import React, {useState, useEffect, useRef} from 'react';
import '../../assets/css/card-slider.css';
import arrowImg from '../../assets/images/icons/errow.png';
import Slider from 'react-slick';
import {requestGetHTTP, requestPostHTTP} from "../helpers/helper";
import Loader from "./Loader";
import {useSelector} from 'react-redux';
import {isLogin} from "../auth/AuthController";
import {NavLink} from "react-router-dom";
import rewardsImg from "../../assets/images/icons/rewards.png";

const TournmentSlider = () => {
    const [weeklyTournament, setWeeklyTournament] = useState([]);
    const [notFoundTournament, setNotFoundTournament] = useState(false);
    const [loading, setLoading] = useState(true);
    const modal = useSelector((state) => state.openSubscribedModal);
    const [tournamentCheckIn, setTournamentCheckIn] = useState([]);
    const showSuccessModal = useRef(null);

    useEffect(() => {
        async function fetchTournamentData() {
            try {
                const getWeeklyTournament = await requestGetHTTP('/v1/tournaments/all');
                if (getWeeklyTournament.data.length > 0) {
                    setWeeklyTournament(getWeeklyTournament.data);
                } else {
                    setNotFoundTournament(true);
                }
            } catch (error) {
                console.error('Error fetching tournament data:', error);
                setNotFoundTournament(true);
            } finally {
                setLoading(false);
            }
        }

        fetchTournamentData();
    }, []);


    /**
     *
     * @param event
     */
    const checkLogin = (event) => {
        if (!isLogin()) {
            event.preventDefault();
            modal.subscribedModalRef.current.click();
        }
    }

    const windowWidth = window.innerWidth;
    let slidesToShow = 3.999;
    if (windowWidth > 850 && windowWidth <= 900) {
        slidesToShow = 2.999;
    } else if (windowWidth <= 850) {
        slidesToShow = 1;
    }
    const settings = {
        dots: false,
        infinite: weeklyTournament.length > 4,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
    };

    return (
        <section>
            <div className="mt-4 cards-wrapper card-slider-wrapper">
                <div className="card-slider-heading">
                    <h2 className="headingz mb-4">Weekly Tournaments
                        <span className="errow-icon">
                            <img src={arrowImg} alt="errow-img"/>
                        </span>
                    </h2>
                </div>

                {loading ? (
                    <Loader/>
                ) : (
                    <Slider {...settings} className="slider card-slider arrow-light slider-gap sliderz">
                        {weeklyTournament.map(cardSlider => (
                            <div key={cardSlider.id} className="cards-round">
                                <NavLink onClick={(event) => checkLogin(event)} to={`/tournament-details/${cardSlider.tourn_id}`}>
                                    <img src={cardSlider.thumbnail} alt="tournament-img"/>
                                    <div className="col-8 cards-info float-start">
                                        <h3 className="cards-label text-white">
                                            {cardSlider.tourn_name}
                                        </h3>
                                        <p className="cardSlider-heading-tournament">Win {cardSlider.prize} Credits</p>
                                        <p className="tournament-total-participant">Participant: {cardSlider.total_checkin}</p>
                                    </div>
                                    <div className="col-4 comming-soon-slider-tournament float-end">
                                        <p>Starting at</p>
                                        <p>{cardSlider.time.split(" ")[0]}</p>
                                        <p>{cardSlider.time.split(" ")[1]}</p>
                                    </div>
                                </NavLink>
                            </div>
                        ))}
                    </Slider>
                )}

                {notFoundTournament && (
                    <div className="d-flex justify-content-center align-items-center no-data-found">
                        <p>No tournaments found</p>
                    </div>
                )}

            </div>
        </section>
    );
}

export default TournmentSlider;
